export default __webpack_public_path__ + "static/media/thumbnail.e58494de.jpg";